import {registerNode} from "@cm/graph-v2-final"
import {ImageOpInputsOrNodes} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {definition} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/reshape/definition"
import {ImageOpReshapeHal} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/reshape/hal"
import {BasicSpecializingImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/basic-specializing-image-op-node"

@registerNode
export class ImageOpNodeReshape extends BasicSpecializingImageOpNode<typeof definition, ImageOpReshapeHal> {
    static nodeClass = "ImageOpNodeReshape"
    static definition = definition

    constructor(parameters: ImageOpInputsOrNodes<typeof definition>) {
        super(ImageOpReshapeHal, parameters)
    }
}
